/* Typed access to Vite env vars. All secrets live in .env.local (gitignored);
 * .env.example documents the required keys. The Flutter build hardcoded the
 * Firebase options and the Maps key in source — we do not repeat that.
 *
 * Emulator mode (VITE_FIREBASE_EMULATOR=1): the Auth emulator ignores API
 * keys, so fake values are substituted and no real secrets are needed for
 * local development. */

export const useEmulator = import.meta.env.VITE_FIREBASE_EMULATOR === '1'

function required(name: string): string {
  const v = import.meta.env[name] as string | undefined
  if (!v) {
    // Fail loudly at first use — a missing key would otherwise surface as an
    // opaque Firebase/Maps error much later.
    throw new Error(`Missing required env var: ${name} (see .env.example)`)
  }
  return v
}

export const env = {
  firebase: {
    get apiKey() {
      return useEmulator ? 'fake-api-key' : required('VITE_FIREBASE_API_KEY')
    },
    authDomain: 'heart2heart-2759a.firebaseapp.com',
    projectId: 'heart2heart-2759a',
    get appId() {
      return useEmulator
        ? '1:000000000000:web:0000000000000000000000'
        : required('VITE_FIREBASE_APP_ID')
    },
  },
  get mapsKey() {
    return required('VITE_GOOGLE_MAPS_KEY')
  },
  get mapId() {
    // Advanced Markers require a Map ID (any vector map id works).
    return required('VITE_GOOGLE_MAPS_ID')
  },
}
